/* global __PREFIX_PATHS__ */
import React, { useEffect } from 'react'
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n'
import { navigate } from 'gatsby'
import './base.css'
import Container from './container'
import Navigation from './Navigation'
import Footer from './footer'
import { IntlProvider } from 'react-intl'
import 'intl'

const Layout = ({
  location,
  navBarData,
  footerData,
  siteLanguages,
  latestBlogPost,
  alertBarData,
  pageAlert,
  children,
}) => {
  const url = location.pathname
  const { langs, defaultLangKey } = siteLanguages
  const langKey = getCurrentLangKey(langs, defaultLangKey, url)
  const homeLink = langKey === 'en-us' ? '/' : `/${langKey}/`
  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url))
  langsMenu.forEach((lang) => {
    if (lang.langKey === 'en-us') {
      lang.link = lang.link.replace('/en-us/', '/')
    }
  })
  const i18nMessages = require(`../data/messages/${langKey}`)

  let navBarLinks = navBarData.links
  let superBarLinks = navBarData.superNavLinks

  if (langKey !== 'en-us') {
    navBarLinks = navBarData.links.map((link) => {
      return {
        ...link,
        defaultUrl: link.defaultUrl
          ? link.defaultUrl.startsWith('http') ||
            link.defaultUrl.startsWith('/zh-cn/') ||
            link.defaultUrl.startsWith('/jp/')
            ? link.defaultUrl
            : `/${langKey + link.defaultUrl}`
          : link.defaultUrl,
        childLinks: link.childLinks.map((childLink) => {
          return {
            ...childLink,
            url:
              childLink?.url?.startsWith('http') ||
              childLink?.url?.startsWith('/zh-cn/') ||
              childLink?.url?.startsWith('/jp/')
                ? childLink.url
                : `/${langKey + childLink.url}`,
          }
        }),
      }
    })

    superBarLinks = navBarData.superNavLinks.map((link) => {
      return {
        ...link,
        defaultUrl: link.defaultUrl
          ? link.defaultUrl.startsWith('http') ||
            link.defaultUrl.startsWith('/zh-cn/') ||
            link.defaultUrl.startsWith('/jp/')
            ? link.defaultUrl
            : `/${langKey + link.defaultUrl}`
          : link.defaultUrl,
      }
    })

    footerData = {
      ...footerData,
      sections: footerData.sections.map((section) => {
        return {
          ...section,
          url:
            section.url.startsWith('http') ||
            section.url.startsWith('/zh-cn/') ||
            section.url.startsWith('/jp/')
              ? section.url
              : `/${langKey + section.url}`,
          sublinks: section.sublinks.map((sublink) => {
            return {
              ...sublink,
              url:
                sublink.url.startsWith('http') ||
                sublink.url.startsWith('/zh-cn/') ||
                sublink.url.startsWith('/jp/')
                  ? sublink.url
                  : `/${langKey + sublink.url}`,
            }
          }),
        }
      }),
      mobileButtons: footerData.mobileButtons.map((button) => {
        return {
          ...button,
          url:
            button.url.startsWith('http') ||
            button.url.startsWith('/zh-cn/') ||
            button.url.startsWith('/jp/')
              ? button.url
              : `/${langKey + button.url}`,
        }
      }),
      privacyPolicyUrl:
        footerData.privacyPolicyUrl.startsWith('http') ||
        footerData.privacyPolicyUrl.startsWith('/zh-cn/') ||
        footerData.privacyPolicyUrl.startsWith('/jp/')
          ? footerData.privacyPolicyUrl
          : `/${langKey + footerData.privacyPolicyUrl}`,
      siteTermsUrl:
        footerData.siteTermsUrl.startsWith('http') ||
        footerData.siteTermsUrl.startsWith('/zh-cn/') ||
        footerData.siteTermsUrl.startsWith('/jp/')
          ? footerData.siteTermsUrl
          : `/${langKey + footerData.siteTermsUrl}`,
    }
  }

  useEffect(() => {
    const ousterLang = window.localStorage.getItem('ouster_dot_com_language')
    const lang = window.navigator.language
    const path = window.location.pathname
    const queryParams = window.location.search
    const chineseLang = lang.startsWith('zh')
    const englishLang = lang.startsWith('en')
    const japaneseLang = lang.startsWith('jp') || lang.startsWith('ja')

    let parts = path
      .split('/')
      .filter((item) => item !== null && item !== undefined && item !== '')

    const uniq = (a) => Array.from(new Set(a))

    const us = (parts) => {
      parts = parts.filter((part) => part !== 'zh-cn' && part !== 'jp')
      parts = uniq(parts)
      navigate(
        parts.length !== 0
          ? `/${parts.join('/')}/` + queryParams
          : `/` + queryParams,
        {
          replace: true,
        }
      )
    }

    const china = (parts) => {
      parts = parts.filter((part) => part !== 'jp')
      parts.unshift('zh-cn')
      parts = uniq(parts)
      navigate(`/${parts.join('/')}/` + queryParams, { replace: true })
    }

    const japan = (parts) => {
      parts = parts.filter((part) => part !== 'zh-cn')
      parts.unshift('jp')
      parts = uniq(parts)
      navigate(`/${parts.join('/')}/` + queryParams, { replace: true })
    }

    switch (true) {
      case ousterLang === 'en-us':
        us(parts)
        break

      case englishLang && ousterLang === 'en-us':
        us(parts)
        break

      case ousterLang === 'zh-cn':
        china(parts)
        break

      case chineseLang && ousterLang !== 'en-us' && ousterLang !== 'jp':
        china(parts)
        break

      case ousterLang === 'jp':
        japan(parts)
        break

      case japaneseLang && ousterLang !== 'en-us' && ousterLang !== 'zh-cn':
        japan(parts)
        break

      default:
        us(parts)
        break
    }
  }, [])

  return (
    <IntlProvider locale={langKey} messages={i18nMessages}>
      <Container>
        <Navigation
          latestBlogPost={latestBlogPost}
          links={navBarLinks}
          superNavLinks={superBarLinks}
          langs={langsMenu}
          locale={langKey}
          alert={alertBarData}
          pageAlert={pageAlert}
          smart
          solid
        />
        <div className="main-content">{children}</div>
        <Footer data={footerData} locale={langKey} />
      </Container>
    </IntlProvider>
  )
}

export default Layout
